import { lazy } from 'react';
import Loadable from 'components/@ui/loader/Loadable';
import { ROLES } from 'variables';

const Licenses = Loadable(lazy(() => import('pages/licenses')));

export const licenseRoutes = [
  {
    path: '/licenses',
    element: <Licenses />,
    allowedRoles: [ROLES.Supplier, ROLES.Retailer, ROLES.Admin],
    featureCode: 'licenses'
  }
];
